export default __webpack_public_path__ + "static/media/74.888893a6.jpg";